












































import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'
import { countHalfwidth } from '../js/string'
import Countries from '../data/country'

const NAME_CHAR_LIMIT = 32
const OUTGOING_CHAR_LIMIT = 64
const MISSION_CHAR_LIMIT = 256

interface Validation {
  name?: string
  outgoing_message?: string
  mission_message?: string
}

export default Vue.extend({
  name: 'ticket-editor',
  props: {
    lang: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    countryCode: {
      type: String,
      default: 'JP'
    },
    outgoingMessage: {
      type: String,
      default: ''
    },
    missionMessage: {
      type: String,
      default: ''
    },
    confirmPublishing: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object as () => Validation,
      default: () => ({})
    }
  },
  data() {
    return {
      NAME_CHAR_LIMIT,
      OUTGOING_CHAR_LIMIT,
      MISSION_CHAR_LIMIT,
      countries: Countries,
      localName: this.name,
      localCountryCode: this.countryCode,
      localOutgoingMessage: this.outgoingMessage,
      localMissionMessage: this.missionMessage,
      localConfirmPublishing: this.confirmPublishing
    }
  },
  computed: {
    nameCounter(): number {
      return countHalfwidth(this.localName)
    },
    outgoingMessageCounter(): number {
      return countHalfwidth(this.localOutgoingMessage)
    },
    missionMessageCounter(): number {
      return countHalfwidth(this.localMissionMessage)
    }
  },
  watch: {
    localName(val) {
      this.$emit('update:name', val)
    },
    localCountryCode(val) {
      this.$emit('update:countryCode', val)
    },
    localOutgoingMessage(val) {
      this.$emit('update:outgoingMessage', val)
    },
    localMissionMessage(val) {
      this.$emit('update:missionMessage', val)
    },
    localConfirmPublishing(val) {
      this.$emit('update:confirmPublishing', val)
    }
  },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    },
    handleConfirm() {
      this.$emit('confirm', {
        name: this.localName,
        countryCode: this.localCountryCode,
        outgoingMessage: this.localOutgoingMessage,
        missionMessage: this.localMissionMessage,
        confirmPublishing: this.localConfirmPublishing
      })
    }
  }
})
